import { render, staticRenderFns } from "./SelectMenuFilter.vue?vue&type=template&id=2dfc0640&"
import script from "./SelectMenuFilter.vue?vue&type=script&lang=ts&"
export * from "./SelectMenuFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMenuFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports